import { uniqueId } from 'lodash';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { Card, CardBody, CardFooter, CardHeader } from 'reactstrap';
import { InfoLabel, Loader, PercentChangeIndicator } from '../../../common/components';
import DashboardInfoLabel from '../utils/DashboardInfoLabel';
import DashboardTooltip from '../utils/DashboardTooltip';
import { currencyFormatter, currencyFormatterInShort } from '../utils/dashboardConstants';

function DashboardCardLayout({
  title,
  cardTitle,
  tooltip,
  children,
  footer = null,
  options = {},
  data = {},
  className,
  loader,
}) {
  const filterData = useSelector((state) => state.filters.dashboardMultiSelectFilters);
  const parentChildStatus = useSelector((state) => state.filters.dashboardParentChildStatus);
  return (
    <div className="dashboard-overview-card">
      <DashboardInfoLabel
        id={uniqueId('card-layout')}
        label={title}
        showIcon
        toolTipText={tooltip}
        className="dashboard-overview-card-title"
      />
      <Card className="dashboard-overview-card-layout">
        {loader ? (
          <Loader />
        ) : (
          <>
            <CardHeader
              className="card-header-wrapper"
              style={{ backgroundColor: options.bgColor }}
            >
              <div className="title-date-wrapper">
                <InfoLabel label={cardTitle} />
                <p className="card-date">
                  {`Last updated: ${
                    data.date !== '-'
                      ? new Date(data.date).toLocaleDateString('en-US', {
                          month: 'short',
                          day: 'numeric',
                          year: 'numeric',
                        })
                      : '-'
                  }`}
                </p>
              </div>
              <div className="amount-percent-wrapper">
                <DashboardTooltip
                  id={uniqueId('amount-percent-wrapper')}
                  position="bottom"
                  value={data.amount}
                  label={currencyFormatterInShort(data.amount)}
                  tooltipText={currencyFormatter(data.amount)}
                />
                {typeof data.percent === 'number' ? (
                  <PercentChangeIndicator percent={data.percent} />
                ) : null}
              </div>
            </CardHeader>
            {children && (
              <CardBody className={`dashboard-overview-card-body ${className}`}>
                {children}
              </CardBody>
            )}
            {footer && <CardFooter>{footer}</CardFooter>}
          </>
        )}
      </Card>
      {data.redirection.enabled && typeof data.amount === 'number' && (
        <p className="card-redirection-label">
          <span>{`Get overall ${title} report`}</span>
          <button
            type="button"
            className="redirection-btn"
            onClick={() => {
              data.redirection.redirect({
                pathname: data?.redirection?.path,
                filterType: data?.redirection?.filterType,
                reportDate: '',
                startDate: '',
                endDate: '',
                duration: null,
                value: data?.redirection?.values,
                redirectionFrom: 'dashboard',
                globalFilters: filterData,
                parentChildStatus,
              });
            }}
          >
            here
          </button>
        </p>
      )}
    </div>
  );
}

DashboardCardLayout.propTypes = {
  title: PropTypes.string.isRequired,
  cardTitle: PropTypes.string.isRequired,
  tooltip: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  footer: PropTypes.element,
  options: PropTypes.shape({}),
  data: PropTypes.shape({}),
  className: PropTypes.string,
  loader: PropTypes.bool.isRequired,
};

DashboardCardLayout.defaultProps = {
  footer: null,
  options: {},
  data: {},
  className: '',
};

export default DashboardCardLayout;
